// extracted by mini-css-extract-plugin
module.exports = {"searchItems":"index_searchItems__fZPsQ","form":"index_form____hj2","title":"index_title__YLNI9"};